import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="payment-method"
export default class extends Controller {
  static targets = ["submitLabel"];
  static values = {
    creditLabel: {
      type: String,
      default: '払戻手数料のお支払いへ<span class="icon-blank">新しいウインドウで開く</span>',
    },
    bankLabel: { type: String, default: "払戻依頼をする" },
  };

  change(event) {
    const method = event.currentTarget.value;
    if (this.hasSubmitLabelTarget) {
      this.submitLabelTarget.innerHTML = method === "credit" ? this.creditLabelValue : this.bankLabelValue;
    }
  }
}
